// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * DEV ERROR UNIFIED OVERLAY
 * Solo activo en entorno desarrollo.
 * Permite visualizar error técnico sin doble modal.
 * NO habilitar en producción.
 */

const isDev =
  typeof import.meta !== 'undefined' &&
  (import.meta.env?.DEV === true || import.meta.env?.VITE_APP_ENV === 'development');

/**
 * Feature flag interna (solo frontend, no en BD).
 * true cuando import.meta.env.DEV === true o VITE_APP_ENV === 'development'.
 * En producción siempre false.
 */
export function isDevErrorUnifiedModal() {
  return !!isDev;
}

export default isDevErrorUnifiedModal;
